export default __webpack_public_path__ + "static/media/pages.9d087fc8.jpg";